import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function inventoryPrivilegeFormModel() {
  const inventoryPrivilegeFormCreate = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Create",
    method: "POST",
    payload: {
      Inv_Scope: 1, //required   1: Brand / 2: Store/Branch  -> default = 1
      Code: null, // เดี๋ยวตรงนี้มาทำเพิ่มทีหลัง เป็น ref ที่ใช้เรียกภายในแทน inv_reference
      Name: "", //required
      Detail: "",
      Remark: "",
      Req_Identity_Id: 1, //required
    },
  });

  const inventoryPrivilegeFormEdit = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Edit",
    method: "POST",
    payload: {
      Inventory_Id: null, //required
      Name: "", //required
      Detail: "",
      Remark: "",
      Req_Identity_Id: 1, //required
    },
  });

  const inventoryPrivilegeFormDetail = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Detail",
    method: "POST",
    payload: {
      Inventory_Id: null, //required
    },
  });

  const fetchAssignEntryInventory = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Assign_Inventory_Entry",
    method: "POST",
    payload: {
      Privilege_Id: 0, //required
      Inventory_Id: 0, // Assign to Custom Inventory //required
      Req_IdentityId: 1, //required
    },
  });

  const fetchPrivilegeEntryDetail = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Entry_Detail",
    method: "POST",
    payload: {
      Inventory_Id: 0, //required
      Privilege_Id: 0, //required
    },
  });

  const fetchPrivilegeEntryEditReward = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Entry_Edit",
    method: "POST",
    payload: {
      Entry_Id: 0, //required
      Stock_Mode: 1, //required  1 = No Stock Control / 2 = Oversellings / 3 = Restricted
      Fullfillment_Mode: 1, //required 1 = FIFO , 2 = FEFO , 3 = LIFO
      Minimun_Qty: 0, // default 0 -> modify later
      Req_IdentityId: 1,
      Type: "add", // ใช้ concept key   "add" , "withdraw" , "import" , "export"
      Qty: 0, //required
      Note: "",
      Removal_Stategy: 1, //only for cpc 1 = FIFO , 2 = FEFO , 3 = LIFO  default = 1 ถ้าไม่ตรง privilege type มันจะไม่สนใจ
    },
  });

  const fetchPrivilegeEntryImportCpc = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Entry_Edit",
    method: "POST",
    payload: {
      Entry_Id: 0, //required
      Stock_Mode: 1, //required  1 = No Stock Control / 2 = Oversellings / 3 = Restricted
      Fullfillment_Mode: 1, //required 1 = FIFO , 2 = FEFO , 3 = LIFO
      Minimun_Qty: 0, // default 0 -> modify later
      Req_IdentityId: 1,
      Type: "import", // ใช้ concept key   "add" , "withdraw" , "import" , "export"
      Note: "",
      Duplicate_Mode: 1,
      Import_File : null
    },
  });

  const fetchPrivilegeEntryExportCpc = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Entry_Edit",
    method: "POST",
    payload: {
      Entry_Id: 0, //required
      Stock_Mode: 1, //required  1 = No Stock Control / 2 = Oversellings / 3 = Restricted
      Fullfillment_Mode: 1, //required 1 = FIFO , 2 = FEFO , 3 = LIFO
      Minimun_Qty: 0, // default 0 -> modify later
      Req_IdentityId: 1,
      Type: "export", // ใช้ concept key   "add" , "withdraw" , "import" , "export"
      Note: "",
      Removal_Stategy: 1,
      Withdraw : 0
    },
  });

  const fetchTransferInventoryList = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Transfer_List",
    method: "POST",
    payload: {
      Privilege_Id: 0,
      Inventory_Id: 0,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const fetchTransferQty = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Transfer",
    method: "POST",
    payload: {
      Entry_Id: 0, //required
      To_Inventory_Id: 0, //required
      Qty: 1, //required
      Note: "",
      Removal_Stategy: 1, //required    //only for cpc -> 1 = FIFO , 2 = FEFO , 3 = LIFO  default = 1 ถ้าไม่ตรง privilege type มันจะไม่สนใจ
      Req_IdentityId: 1, //required
    },
  });

  return {
    inventoryPrivilegeFormCreate,
    inventoryPrivilegeFormEdit,
    inventoryPrivilegeFormDetail,
    fetchAssignEntryInventory,
    fetchPrivilegeEntryDetail,
    fetchPrivilegeEntryEditReward,
    fetchTransferInventoryList,
    fetchTransferQty,
    fetchPrivilegeEntryImportCpc,
    fetchPrivilegeEntryExportCpc
  };
}
